/** Serialize iframe creation; simultaneous TinyMCE mounts can race in embedded browsers. */
export function createEditorInitializationQueue() {
  const pending = [];
  let active;
  function advance() {
    if (active || !pending.length) return;
    active = pending.shift();
    active.start();
  }
  return {
    enqueue(start) {
      const entry = { start };
      pending.push(entry);
      advance();
      return () => {
        const index = pending.indexOf(entry);
        if (index >= 0) pending.splice(index, 1);
        if (active === entry) { active = undefined; advance(); }
      };
    },
  };
}

export const editorInitializationQueue = createEditorInitializationQueue();
